export default class GetSubtiposConvocatoriaByTipo {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idTipoConvocatoria) {
    try {
      const result = await this.#repository.getSubtiposConvocatoriaByTipo(idTipoConvocatoria)
      return result
    } catch (error) {
      console.error('Error al obtener los subtipos de convocatoria por tipo:', error)
      throw error
    }
  }
}
